/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

export interface IFancyConfig {
	/** full url starting with http */
	firebaseDatabaseUrl: string | undefined;
	/** the firebase root, usually is 'Root' */
	firebaseRefUrl: string;
	/** enable partitioning */
	enablePartitioning: boolean;
}

export class FancyConfig implements IFancyConfig {
	public firebaseDatabaseUrl!: string;
	public firebaseRefUrl!: string;
	public enablePartitioning!: boolean;

	public init(config: IFancyConfig): void {
		Object.assign(this, config);
	}
}

export const fancyConfig: FancyConfig = new FancyConfig();
